import { render, staticRenderFns } from "./Pods.vue?vue&type=template&id=55985ade&scoped=true&"
import script from "./Pods.vue?vue&type=script&lang=js&"
export * from "./Pods.vue?vue&type=script&lang=js&"
import style0 from "./Pods.vue?vue&type=style&index=0&id=55985ade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55985ade",
  null
  
)

export default component.exports